import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./AssistantThinkingLoader.scss";

const AssistantThinkingLoader = () => {
    const task_status_message = useSelector((state) => state.chat.taskStatusMessage);

    const deriveStatus = (status) => {
        if (!status) return null;
        if (typeof status === "string") return status;
        return status.taskMessage || status.message || status.taskTitle || null;
    };

    const [statusMessage, setStatusMessage] = useState(deriveStatus(task_status_message));

    useEffect(() => {
        setStatusMessage(deriveStatus(task_status_message));
    }, [task_status_message]);

    return (
        <div className="assistant-thinking-loader">
            <div className="thinking-bubble">
                <div className="thinking-dots">
                    <span className="thinking-dot" />
                    <span className="thinking-dot" />
                    <span className="thinking-dot" />
                </div>
                {statusMessage && (
                    <span className="thinking-status-text">
                        {statusMessage}
                    </span>
                )}
            </div>
        </div>
    );
};

export default AssistantThinkingLoader;
